import React, { Component } from 'react';
import {
    Row, Col,
    Card, CardBody,
    UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem,
    ListGroup, ListGroupItem, Button, Popover, PopoverBody
} from 'reactstrap';
import { connect } from 'react-redux';
import Accordion from '../../components/accordion/index';
import { getCounterpartyType, selectedCounterparty } from '../../Analyst/Cases/Create/actions'
import data from './dashboard.json';
import './dashboard.scss';
import * as constant from './constant'
import * as dashboardAction from './action'
import {caseCountByStateData} from './action'
import { searchText, searchParameter } from '../corporate/action'
import { setPortfolioFilters, createUrlParameter, getUrlParameter } from './helper';
import { Preloading } from '../../components/UI/Preloader/action';
import { createFilterUrl } from '../my-portfolio/helper';
import { setPageView, goolgeAnalyticsEvents } from '../../components/GoogleAnalytics/index';
class Dashboard extends Component {
    constructor(props, state) {
        super(props, state);
        this.state = {
            selected: "",
            clickedAside: "",
            title: "Regions",
            accordiondata: [],
            dashboardData: [],
            mapData: null,
            switch: false,
            popoverOpenTotalCompannies: false,
            popoverOpenBusinessRelations: false,
            caseCountDataByState:this.props.getCaseCountByStateSuccess ? this.props.getCaseCountByStateSuccess :{},
            stateMapPreloader:false,
            corporateId:'',
            selectedCounterpartyType:''
        };
    }

    componentDidMount() {
        setPageView('/Corporate/Dashboard', document.location.href);
        this.props.getCounterpartyType();
        this.props.setFilters([]);
        if (!this.props.match.params.dashboardView) {
            this.props.history.push(`/dashboard/${constant.GEOGRAPHY}`)
        };
        let initialCounterPartyType = getUrlParameter(this.props.location.search);
        if (initialCounterPartyType === null && this.props.counterpartiesDashboardData.length > 0) {
            initialCounterPartyType = this.props.counterpartiesDashboardData[0].counterpartyType;
        } else{
             initialCounterPartyType = this.props.counterpartyTypeList && this.props.counterpartyTypeList.length>0 && this.props.counterpartyTypeList[0];
        }
        let corporateID = this.props.counterpartiesDashboardData[0] && this.props.counterpartiesDashboardData[0].corporateId;
        corporateID && initialCounterPartyType && this.invokeIndianMapData(corporateID,initialCounterPartyType);
    }
    componentDidUpdate(prevProps) {
        const { dashboardData, counterpartyTypeList, checkDashboard, checkDashboardDataFailure, counterpartiesDashboardData, getCaseCountByStateSuccess, getCaseCountByStateFailure } = this.props;

        if (getCaseCountByStateSuccess !== prevProps.getCaseCountByStateSuccess) {
            this.setState({caseCountDataByState:getCaseCountByStateSuccess,
                stateMapPreloader:false});
        }
        if (getCaseCountByStateFailure !== prevProps.getCaseCountByStateFailure) {
            this.setState({stateMapPreloader:false});
        }
        if((counterpartiesDashboardData !== prevProps.counterpartiesDashboardData)){
            let corporateID = counterpartiesDashboardData[0] && counterpartiesDashboardData[0].corporateId;
            let selectedCounterParty = counterpartiesDashboardData.filter(item => item.counterpartyType === this.state.selectedCounterpartyType);
            let selectedCounterPartyType = (counterpartiesDashboardData.length > 1 && this.state.selectedCounterpartyType && selectedCounterParty && selectedCounterParty[0]) ? selectedCounterParty[0].counterpartyType : counterpartiesDashboardData[0].counterpartyType;
            corporateID && selectedCounterPartyType && this.invokeIndianMapData(corporateID,selectedCounterPartyType);
            counterpartiesDashboardData[0] && this.setState({corporateId:counterpartiesDashboardData[0].corporateId});
        }

        // Dashboard caching
        let counterpartyType = getUrlParameter(this.props.location.search);
        if (counterpartyType === null && counterpartiesDashboardData.length > 0) {
            counterpartyType = counterpartiesDashboardData[0].counterpartyType;
        }
        let counterpartyTypeCache = [];
        // Get counterparty type from cached dashboard data
        counterpartiesDashboardData.map(data => counterpartyTypeCache.push(data.counterpartyType));
        if (counterpartyType !== null && counterpartyTypeCache.indexOf(counterpartyType) >= 0) {
            this.props.preloading(false);
            for (let index = 0; index < counterpartiesDashboardData.length; index++) {
                // If counterpart type or dashboardview changed
                if ((counterpartyType === counterpartiesDashboardData[index].counterpartyType && counterpartyType !== this.state.selected) || (counterpartyType === counterpartiesDashboardData[index].counterpartyType && this.props.match.params.dashboardView !== prevProps.match.params.dashboardView)) {
                    this.setState({
                        selected: counterpartyType,
                        dashboardData: counterpartiesDashboardData[index]
                    });
                    this.handledashboardView(this.props.match.params.dashboardView, counterpartiesDashboardData[index]);
                    break;
                }
            }
            return;
        }

        if (counterpartyTypeList !== prevProps.counterpartyTypeList) {
            this.setState({
                /*selected: counterpartyTypeList[0],*/
                accordiondata: dashboardData.geography
            })
            this.handleUrlParameter()
            this.props.preloading(true);
        }
        if (this.props.match.params.dashboardView !== prevProps.match.params.dashboardView || this.props.location.search !== prevProps.location.search) {
            this.handleUrlParameter()
        }
        if (dashboardData !== prevProps.dashboardData) {
            this.setState({
                /*selected: dashboardData.counterpartyType,*/
            });
            this.props.preloading(false);
            // this.handleUrlParameter()
            //this.handledashboardView(this.props.match.params.dashboardView);
            if (this.props.location.search) {
                const url = createUrlParameter(dashboardData.counterpartyType)
                this.props.history.push(`?${url}`);
            }
        }       
    }

    invokeIndianMapData=(corporateId, counterpartyType)=>{
        let requestData={
            corporateId:corporateId,
            counterpartyType:counterpartyType
        }
        this.props.getCaseCountByState(requestData);
        this.setState({stateMapPreloader:true});
    }

    handleUrlParameter = () => {
        const urlParameter = getUrlParameter(this.props.location.search);
        if (urlParameter) {
            this.props.getDashboardData(urlParameter)
        } else {
            this.props.checkDashboardData();
        }
    }
    handleDropdown = (value) => {
        goolgeAnalyticsEvents('Corporate', 'Change Counterparty Type and View Data', 'Update Couterparty Type', value);
        if (this.state.selected !== value) {
            /*this.setState({
                selected: value
                // switch: this.state.switch
            }, () => { this.props.preloading(true); })*/
            this.props.preloading(true);
            const url = createUrlParameter(value)
            this.props.history.push(`/dashboard/${this.props.match.params.dashboardView}?${url}`);
        }
        // this.props.getDashboardData(value)
        this.setState({
            selectedCounterpartyType: value
        });
        let {counterpartiesDashboardData}=this.props;
        let corporateID = counterpartiesDashboardData[0] && counterpartiesDashboardData[0].corporateId;
        let selectedCounterPartyType = this.state.selectedCounterpartyType !== value && value;
        corporateID && selectedCounterPartyType && this.invokeIndianMapData(corporateID,selectedCounterPartyType);
    }
    applyFilter = (type, riskLevel, trend, status, country, caseType,state) => {
        let filterList = setPortfolioFilters(type, riskLevel, trend, status, this.state.clickedAside, this.state.selected, country, caseType,state)
        // this.props.setFilters(filterList)
        const url = createFilterUrl(filterList, '', '');

        goolgeAnalyticsEvents('Corporate', `Update Filter From Dashboard`, 'Dashboard Filter');
        this.props.history.push(`/my-portfolio/${1}?${url}`)
    }
    handledashboardView = (param, dashboardData) => {
        //const { dashboardData } = this.props
        console.log("handledashboardView param: ", param);
        let title, clickedAside, internationalData = null, accordiondata = null, map = null;
        switch (param) {
            case constant.GEOGRAPHY:
                title = "Regions"
                clickedAside = constant.GEOGRAPHY
                accordiondata = dashboardData.geography
                map = dashboardData.internationalGeography
                break;
            case constant.BUSINESSSEGMENT:
                title = "Segment Name"
                clickedAside = constant.BUSINESSSEGMENT
                accordiondata = dashboardData.businessSegment
                break;
            case constant.LEGALCONSTITUTION:
                title = "Legal Constitution"
                clickedAside = constant.LEGALCONSTITUTION
                accordiondata = dashboardData.legalConstitution
                break;
            case constant.NICSEGMENT:
                title = "Industry Segment (NIC)"
                clickedAside = constant.NICSEGMENT
                accordiondata = dashboardData.nicSegment
                break;
            default:
        }
        this.setState({
            title: title,
            clickedAside: clickedAside,
            accordiondata: accordiondata,
            mapData: map
        })
    }
    handleClick = (e, param) => {
        this.props.preloading(true);
        goolgeAnalyticsEvents('Corporate', `Updated Segment ${param}`, 'Update Segment');
        e.preventDefault();
        const url = createUrlParameter(this.state.selected)
        this.props.history.push(`/dashboard/${param}?${url}`);
    }
    handleInternationalFlag = (flag) => {
        this.setState({
            switch: flag
        })
    }
    toggleTotalCompanies = (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.setState({
            popoverOpenTotalCompanies: !this.state.popoverOpenTotalCompanies
        });
    }
    toggleBusinessRelations = (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.setState({
            popoverOpenBusinessRelations: !this.state.popoverOpenBusinessRelations
        });
    }
    render() {
        let dropdownList
        let avgscore
        let completedCases
        let incompleteCases
        let trend
        let noOfCompanies
        let businessRelations
        const { counterpartyTypeList } = this.props
        const { dashboardData } = this.state
        if (!counterpartyTypeList.error) {
            dropdownList = counterpartyTypeList.map(value => {
                return <DropdownItem className="dropdown-dealer__item" key={value} onClick={() => this.handleDropdown(value)}>{value}</DropdownItem>
            })
        }
        if (dashboardData.geography) {
            avgscore = Number(dashboardData.geography.ALL.avgScore).toFixed(0);
            completedCases = dashboardData.geography.ALL.completedCases
            incompleteCases = dashboardData.geography.ALL.incompleteCases
            trend = dashboardData.geography.ALL.trends
            noOfCompanies = dashboardData.geography.ALL.numberOfCompanies
            businessRelations = dashboardData.geography.ALL.businessRelations
        }
        // check for clicked element is Business Segment or NIC Segment and create a variable accord..
        let businessNicColumn;
        if (this.state.clickedAside === constant.BUSINESSSEGMENT) {
            businessNicColumn = <Col sm="19" className={(this.state.clickedAside === constant.BUSINESSSEGMENT) ? "dashboard-details dashboard-business-segment" : "dashboard-details"}>
            <Row>
                <Col>
                    <Accordion
                        titleData={{ title: this.state.title, clickedAside: this.state.clickedAside }}
                        data={this.state.accordiondata}
                        filter={this.applyFilter}
                        mapData={this.state.mapData}
                        switchValue={this.state.switch}
                        internationalFlagCallback={this.handleInternationalFlag}
                        allBusinessSegment={dashboardData.allBusinessSegment}
                        corporateColor={this.props.corporateColor}
                        caseCountDataByState={this.state.caseCountDataByState}
                        stateMapPreloader={this.state.stateMapPreloader}
                        corporateId={this.state.corporateId}
                        ></Accordion>
                </Col>
            </Row>
        </Col>
        } else {
            businessNicColumn = <Col sm="19" className={(this.state.clickedAside === constant.NICSEGMENT) ? "dashboard-details dashboard-nic-segment" : "dashboard-details"}>
            <Row>
                <Col>
                    <Accordion
                        titleData={{ title: this.state.title, clickedAside: this.state.clickedAside }}
                        data={this.state.accordiondata}
                        filter={this.applyFilter}
                        mapData={this.state.mapData}
                        switchValue={this.state.switch}
                        internationalFlagCallback={this.handleInternationalFlag}
                        allBusinessSegment={dashboardData.allBusinessSegment}
                        corporateColor={this.props.corporateColor}
                        caseCountDataByState={this.state.caseCountDataByState}
                        stateMapPreloader={this.state.stateMapPreloader}
                        corporateId={this.state.corporateId}
                        ></Accordion>
                </Col>
            </Row>
        </Col>
        }
        return (
            <Col className="dashboard">
                <Card className="mb-3">
                    <CardBody className="row py-0 py-sm-3 px-0">
                        <Col sm="5" className="d-flex align-items-center">
                            <UncontrolledDropdown className="dropdown-dealer">
                                <DropdownToggle className="dropdown-dealer__selected" caret>
                                    {this.state.selected}
                                </DropdownToggle>
                                <DropdownMenu className="px-3">
                                    {dropdownList}
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </Col>
                        <Col sm="19" className="py-3 py-sm-0">
                            <Row>
                                <Col md="6" xs="12" className="text-center text-sm-left mb-3 mb-sm-0 user-stats">
                                    <h3>{avgscore}<sub>/100</sub></h3>
                                    <label className="text-truncate user-stats-count">Rubix Average Score</label>
                                </Col>
                                <Col md="6" xs="12" className="text-center text-sm-left mb-3 mb-sm-0 user-stats">
                                    <h3>{noOfCompanies}</h3>
                                    {/*<label className="text-truncate user-stats-count pointer" onClick={() => this.applyFilter('', '', '')}>Total Companies</label>*/}
                                    <label className="user-stats-count pointer">Total Companies</label>
                                    <Button size="sm" color="link" onClick={(event) => this.toggleTotalCompanies(event)} id="PopoverTotalCompanies">
                                        <i className="icon-info"></i>
                                    </Button>
                                    <Popover className="popover-dashboard" placement="bottom" isOpen={this.state.popoverOpenTotalCompanies} target="PopoverTotalCompanies" toggle={this.toggleTotalCompanies}>
                                        <PopoverBody>Unique number of counterparties</PopoverBody>
                                    </Popover>
                                </Col>
                                {/*<Col md="5" xs="12" className="text-center text-sm-left mb-3 mb-sm-0 user-stats pointer" onClick={() => this.applyFilter('', '', constant.DOWN)}>
                                    <h3>{trend}<i className="icon-long-arrow-down text-danger"></i></h3>
                                    <label className="user-stats-count cursor-pointer">Downgrades</label>
                                </Col>*/}
                                <Col md="6" xs="12" className="text-center text-sm-left mb-3 mb-sm-0 user-stats pointer" onClick={() => this.applyFilter('', '', '', constant.COMPLETE)}>
                                    <h3>{businessRelations}{/*<i className="icon-long-arrow-down text-danger"></i>*/}</h3>
                                    <label className="user-stats-count cursor-pointer">Business Relations</label>
                                    <Button size="sm" color="link" onClick={(event) => this.toggleBusinessRelations(event)} id="PopoverBusinessRelation">
                                        <i className="icon-info"></i>
                                    </Button>
                                    <Popover className="popover-dashboard" placement="bottom" isOpen={this.state.popoverOpenBusinessRelations} target="PopoverBusinessRelation" toggle={this.toggleBusinessRelations}>
                                        <PopoverBody>Business Relations is the count of counterparties dealt by different Divisions and Zones</PopoverBody>
                                    </Popover>
                                </Col>
                                {/*<Col md="5" xs="12" className="text-center text-sm-left user-stats pointer" onClick={() => this.applyFilter('', '', '', constant.COMPLETE)}>
                                    <h3>{completedCases}<i className="icon-check text-success ml-1"></i></h3>
                                    <label className="text-truncate user-stats-count cursor-pointer">Completed Cases</label>
                                </Col>*/}
                                <Col md="6" xs="12" className="text-center text-sm-left user-stats pointer" onClick={() => this.applyFilter('', '', '', constant.PENDING)}>
                                    <h3>{incompleteCases}<i className="icon-in-progress text-warning"></i></h3>
                                    <label className="user-stats-count cursor-pointer">In Progress</label>
                                </Col>
                            </Row>
                        </Col>
                    </CardBody>
                </Card>
                <Row noGutters>
                    <Col sm="5" className="pr-sm-3 mb-3 mb-sm-0">
                        <Card className="dashboard-listgroup">
                            <CardBody className="px-0">
                                <ListGroup tag="div" className="flex-row flex-sm-column justify-content-between align-items-center align-items-sm-start pointer">
                                    <ListGroupItem tag="a" href="" className={this.state.clickedAside === constant.GEOGRAPHY ? 'active' : ''} onClick={(e) => this.handleClick(e, data.geography)}>{data.geography}</ListGroupItem>
                                    {/* {dashboardData.geography ? <ListGroupItem tag="a" className="active" onClick={() => this.handleClick(data.geography)}>{data.geography}</ListGroupItem> : <div></div>} */}
                                    {dashboardData.businessSegment ? <ListGroupItem tag="a" href="" className={this.state.clickedAside === constant.BUSINESSSEGMENT ? 'active' : ''} onClick={(e) => this.handleClick(e, data.businessSegment)}>{data.businessSegment}</ListGroupItem> : <div></div>}
                                    {this.state.switch === false ? dashboardData.legalConstitution ? <ListGroupItem tag="a" href="" className={this.state.clickedAside === constant.LEGALCONSTITUTION ? 'active' : ''} onClick={(e) => this.handleClick(e, data.legalConstitution)}>{data.legalConstitution}</ListGroupItem> : <div></div> : ''}
                                    {dashboardData.nicSegment ? <ListGroupItem tag="a" href="" className={this.state.clickedAside === constant.NICSEGMENT ? 'active' : ''} onClick={(e) => this.handleClick(e, data.nicSegment)}>{data.nicSegment}</ListGroupItem> : <div></div>}
                                </ListGroup >
                            </CardBody >
                        </Card >
                    </Col >
                    {businessNicColumn}
                </Row >
            </Col >
        );
    }
}
const mapStateToProps = (state, ownProps) => ({
    counterpartyTypeList: state.createCase.dropdownData,
    dashboardData: state.dashboard.dashboardData,
    checkDashboard: state.dashboard.checkDashboardData,
    checkDashboardDataFailure: state.dashboard.checkDashboardDataFailure,
    corporateColor: state.corporate.corporateColor,
    counterpartiesDashboardData: state.dashboard.counterpartiesDashboardData,
    getCaseCountByStateSuccess: state.dashboard.getCaseCountDataByState,
    getCaseCountByStateFailure: state.dashboard.getCaseCountByStateFailure,
})

const mapDispatchToProps = (dispatch) => ({
    checkDashboardData: () => { dispatch(dashboardAction.checkDashboardData()) },
    getCounterpartyType: () => { dispatch(getCounterpartyType()) },//dashboardAction
    getDashboardData: (type) => { dispatch(dashboardAction.getDashboardData(type)) },
    setFilters: (filters) => { dispatch(dashboardAction.setFilters(filters)) },
    searchParameter: (searchParam) => { dispatch(searchParameter(searchParam)) },
    searchText: (search) => { dispatch(searchText(search)) },
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
    getCaseCountByState: (data) => { dispatch(dashboardAction.getCaseCountByState(data))}
});
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
